import colors from "Modules/dashboard/views/chart/vars.scss";

export const backgroundColor = [
  colors['dashboard-primary-1'],
  colors['dashboard-primary-2'],
  colors['dashboard-primary-3'],
  colors['dashboard-secondary-1'],
  colors['dashboard-secondary-2'],
  colors['dashboard-secondary-3'],
  colors['dashboard-secondary-4'],
  colors['dashboard-secondary-5'],
  colors['dashboard-secondary-6'],
  colors['dashboard-secondary-7'],
  colors['dashboard-secondary-8'],
  colors['dashboard-secondary-9'],
  colors['dashboard-secondary-10'],
  colors['dashboard-secondary-11'],
  colors['dashboard-secondary-12'],
  colors['dashboard-secondary-13'],
  colors['dashboard-secondary-14'],
  colors['dashboard-secondary-15'],
  colors['dashboard-secondary-16'],
  colors['dashboard-secondary-17'],
  colors['dashboard-secondary-18'],
  colors['dashboard-secondary-19'],
  colors['dashboard-secondary-20'],
  colors['dashboard-secondary-21'],
  colors['dashboard-secondary-22'],
]
